import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { PasswordInput } from '@atlas/ui';

import Field from 'common/Form/Field';

const TextField = ({ field, onBlur, onChange, onFocus }) => {
  const {
    active,
    autocomplete,
    autofocus,
    disabled,
    errors,
    isTypeText,
    label,
    name,
    placeholder,
    touched,
    value,
  } = field;
  const inputValue = value === null ? '' : value;
  const changeHandler = useCallback(event => onChange(event.target.value), [onChange]);
  const error = touched && errors[0];

  return (
    <Field className="field-password" isSignupForm options={field}>
      <PasswordInput
        active={active}
        autoComplete={autocomplete}
        autoFocus={autofocus}
        disabled={disabled}
        error={error}
        isTypeText={isTypeText}
        label={label}
        name={name}
        onBlur={onBlur}
        onChange={changeHandler}
        onFocus={onFocus}
        placeholder={placeholder}
        touched={touched}
        value={inputValue}
      />
    </Field>
  );
};

TextField.propTypes = {
  field: PropTypes.shape({
    active: PropTypes.bool,
    autocomplete: PropTypes.array,
    autofocus: PropTypes.bool,
    disabled: PropTypes.bool,
    errors: PropTypes.array,
    isTypeText: PropTypes.bool,
    label: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    touched: PropTypes.bool,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
};

export default TextField;
